import React from "react";
import logo from "../../assests/white logo-reaidy.png";
import { apiPostPut } from "../../api/api_methods";
import { useNavigate } from "react-router-dom";

function RazorPayGateway({ amount, orderId }) {
  const navigate = useNavigate();
  //   const logo = "https://www.spotmies.com/spotmies_banner.png";

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // const result = await axios.post("http://localhost:5000/payment/orders");

    // if (!result) {
    //     alert("Server error. Are you online?");
    //     return;
    // }

    // const { amount, id: order_id, currency } = result.data;

    const order_id = orderId;
    const currency = "INR";

    const options = {
      key: "rzp_test_bpCxPvnx0AEIPH", // Enter the Key ID generated from the Dashboard
      //   amount: amount.toString(),
      currency: currency,
      name: "Reaidy (Spotmies)",
      description: "Test Transaction",
      image: { logo },
      order_id: order_id,
      handler: async function (response) {
        console.log(response);
        const data = {
          orderId: order_id,
          paymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          signature: response.razorpay_signature,
        };

        // call payment verification api here and redirect to success page
        const verificationResp = await apiPostPut(
          data,
          "/razorpay/verify-payment",
          "POST"
        );

        if (verificationResp.status === 200) {
          // redirect to success page
          console.log("Payment Successfull");
          return navigate("/payment-success");
        }
        alert("Payment Failed your orderId #" + order_id);
      },
      prefill: {
        name: "Soumya Dey",
        email: "SoumyaDey@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Soumya Dey Corporate Office",
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  return (
    <div className="max-w-md mx-auto bg-white rounded-lg overflow-hidden">
      {/* Company Logo (Banner Logo) */}
      <div className="bg-primary2 p-4">
        <img
          src={logo} // Replace with your banner logo URL
          alt="Company Logo"
          className="w-full h-auto"
        />
      </div>

      <div className="p-4 text-center">
        {/* Price */}
        <h2 className="text-3xl font-bold text-gray-800">₹{amount} </h2>
        <p className="text-gray-600">One-time payment</p>

        {/* Checkout Button */}
        <button
          onClick={displayRazorpay}
          className="mt-4 bg-primary text-white px-6 py-2 rounded-full hover:shadow-lg focus:outline-none"
        >
          Checkout
        </button>
      </div>

      {/* Payment Secure Tag */}
      <div className="p-4 text-center">
        <div className="bg-green-500 text-white px-4 py-2 rounded-full">
          Payment Secure
        </div>
      </div>

      {/* Additional Details */}
      <div className="p-4">
        <p className="text-gray-600">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ac
          libero vel dolor vestibulum euismod.
        </p>
      </div>
    </div>
  );
}

export default RazorPayGateway;
